module.exports = __webpack_public_path__ + "static/media/session_client_back.43bce4de.png";